// SYNCED FROM: VidaReactNative/src/features/AddressVerification/utils/composeCityLine.ts
// Keep in sync. See SYNC.md.
import type { Address } from '../types';

export const composeCityLine = (address: Address): string => {
  const cityAndState = [address.city, address.state].filter(Boolean).join(', ');
  return [cityAndState, address.zip].filter(Boolean).join(' ');
};
